import { create } from "zustand";

type ToastVariant = "info" | "success" | "warning" | "error" | "alert";

interface ToastState {
  toastMessage: string;
  toastHeader: string;
  toastVariant: ToastVariant;
  showToast: boolean;
  setToast: (params: { message: string; header: string; variant: ToastVariant }) => void;
  hideToast: () => void;
}

const useToastStore = create<ToastState>((set) => ({
  toastMessage: "",
  toastHeader: "",
  toastVariant: "info",
  showToast: false,
  setToast: ({ message, header, variant }) =>
    set({ toastMessage: message, toastHeader: header, toastVariant: variant, showToast: true }),
  hideToast: () => set({ showToast: false }),
}));

export { useToastStore };
